import { render, staticRenderFns } from "./ctcp_request.vue?vue&type=template&id=5c5fdfa2&"
import script from "./ctcp_request.vue?vue&type=script&lang=js&"
export * from "./ctcp_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports